import { render } from "./AjakavaRidaTabel.vue?vue&type=template&id=2b1f2f6d&scoped=true&ts=true"
import script from "./AjakavaRidaTabel.vue?vue&type=script&lang=ts"
export * from "./AjakavaRidaTabel.vue?vue&type=script&lang=ts"

import "./AjakavaRidaTabel.vue?vue&type=style&index=0&id=2b1f2f6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1f2f6d"]])

export default __exports__